import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    view: 'feed',
    layout: '1',
    imageColor: 'grayscale',
  },
  itemDesign: {},
  containerDesign: {},
};

export const trustSlice = createSlice({
  name: 'trust',
  initialState,
  reducers: {
    trustStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = {
        shape: itemDesign.shape ?? 'round',
        border: itemDesign.border ?? 'none',
        borderColor: itemDesign.borderColor ?? '#ECECF0',
        shadow: itemDesign.shadow ?? 'none',
        shadowColor: itemDesign.shadowColor ?? '#000000',
      };
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        items: blockContent.items ?? [],
        heading: {
          ...blockContent.heading,
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };

      state.blockDesign = {
        view: blockDesign.view ?? 'feed',
        layout: blockDesign.layout ?? '1',
        imageColor: blockDesign.imageColor ?? 'grayscale',
      };
    },
    trustClear: () => initialState,
    trustUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    trustUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    trustUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    trustUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const { trustStore, trustClear, trustUpdateIsLoading, trustUpdateIsActive, trustUpdateBlockContent, trustUpdateBlockDesign } = trustSlice.actions;

export const selectTrustIsLoading = (state) => state.trust.isLoading;

export const selectTrustId = (state) => state.trust.id;
export const selectTrustUID = (state) => state.trust.uid;
export const selectTrustSID = (state) => state.trust.sid;

export const selectTrustBlockContent = (state) => state.trust.blockContent;
export const selectTrustBlockDesign = (state) => state.trust.blockDesign;

export const selectTrustSortItems = createSelector([selectTrustBlockContent], ({ items }) => {
  return sortItems(items);
});

export const selectTrustItemDesign = (state) => state.trust.itemDesign;
export const selectTrustContainerDesign = (state) => state.trust.containerDesign;

export default trustSlice.reducer;
